/**
 * Mietwagen-Status State Machine — Issue #425, #726
 *
 * Fachlicher Lebenszyklus einer Mietwagen-Akte:
 *
 *   vertrag_offen → uebergeben → in_miete → zurueckgegeben → abgerechnet → abgeschlossen
 *
 * Dieses Modul ist die einzige Quelle der Wahrheit für erlaubte Übergänge.
 * Verwendet von UI-Aktionen (Status-Wechsel-Button, Status-Badge) und
 * server-seitigen Validierungen (sobald Übergänge per API erfolgen).
 *
 * Bewusst frei von DB- oder UI-Abhängigkeiten, damit es im Browser, im
 * Server und in Unit-Tests gleichermaßen läuft.
 */

export const MIETWAGEN_STATUS_VALUES = [
  "vertrag_offen",
  "uebergeben",
  "in_miete",
  "zurueckgegeben",
  "abgerechnet",
  "abgeschlossen",
] as const;

export type MietwagenStatus = (typeof MIETWAGEN_STATUS_VALUES)[number];

const ALLOWED_TRANSITIONS: Record<MietwagenStatus, ReadonlyArray<MietwagenStatus>> = {
  vertrag_offen: ["uebergeben"],
  uebergeben: ["in_miete"],
  in_miete: ["zurueckgegeben"],
  zurueckgegeben: ["abgerechnet"],
  abgerechnet: ["abgeschlossen"],
  abgeschlossen: [],
};

export function canTransition(from: MietwagenStatus, to: MietwagenStatus): boolean {
  return ALLOWED_TRANSITIONS[from]?.includes(to) ?? false;
}
